import { createFileRoute } from "@tanstack/react-router";
import { useMemo } from "react";
import { DailySalesChanges } from "@/features/reports/daily-sales-changes";
import { Visible } from "@/features/visibility/visible";
import { ensureElementVisible } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/raporty/weryfikacja-sprzedazy/zmiany")({
	component: DailySalesChangesPage,
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.raporty.weryfikacja-sprzedazy-zmiany",
			location.pathname,
		);
	},
	validateSearch: (search: Record<string, unknown>) => {
		const now = new Date();
		const year = Number(search.year ?? now.getFullYear());

		return {
			year: Number.isFinite(year) ? year : now.getFullYear(),
		};
	},
});

function DailySalesChangesPage() {
	const search = Route.useSearch();
	const navigate = Route.useNavigate();

	const currentYear = useMemo(() => search.year, [search.year]);
	return (
		<Visible id="page.raporty.weryfikacja-sprzedazy-zmiany" label="Zmiany sprzedazy">
			<DailySalesChanges
				year={currentYear}
				onYearChange={(value) =>
					navigate({
						search: (prev) => ({
							...prev,
							year: value,
						}),
					})
				}
			/>
		</Visible>
	);
}
